/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CardData as AgentApiContractCardData } from '../../models/AgentApi/Contract/card-data';
import { GetCardDataRequest as AgentApiModelsGetCardDataRequest } from '../../models/AgentApi/Models/get-card-data-request';

export interface ApiAgentGetCardDataPost$Plain$Params {

/**
 * Interface language
 */
  lang?: string;
      body?: AgentApiModelsGetCardDataRequest
}

export function apiAgentGetCardDataPost$Plain(http: HttpClient, rootUrl: string, params?: ApiAgentGetCardDataPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractCardData>> {
  const rb = new RequestBuilder(rootUrl, apiAgentGetCardDataPost$Plain.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgentApiContractCardData>;
    })
  );
}

apiAgentGetCardDataPost$Plain.PATH = '/api/Agent/GetCardData';
